import { Panel, Th, Td, RT } from "./ui";

// Read-only CAD chronology — imported from CAD timestamps; never editable in RMS.
export default function SectionCad({ rep }) {
  return (
    <Panel title={`CAD Event Chronology (${rep.cad_chronology.length}) — READ ONLY`} testid="panel-cad">
      <div className="font-mono text-[9px] mb-2" style={{ color: RT.dim }}>
        Imported directly from CAD call {rep.cad_number}. CAD history is read-only in the official RMS report;
        authorized corrections preserve the original entry in Audit History.
      </div>
      <table className="w-full">
        <thead><tr><Th>TIME</Th><Th>UNIT</Th><Th>EVENT TYPE</Th><Th>DESCRIPTION</Th></tr></thead>
        <tbody>
          {rep.cad_chronology.map((e, i) => (
            <tr key={i} data-testid={`cad-row-${i}`}>
              <Td>{e.time || "—"}</Td><Td>{e.unit || "—"}</Td><Td>{e.event_type}</Td>
              <Td mono={false}>{e.description}</Td>
            </tr>
          ))}
        </tbody>
      </table>
    </Panel>
  );
}
